import { forwardRef } from 'react';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import {
  GridClearIcon,
  GridSearchIcon,
  QuickFilterClear,
} from '@mui/x-data-grid';
import type { GridSlotProps, QuickFilterControlProps } from '@mui/x-data-grid';

type QuickFilterState = Parameters<
  Extract<
    NonNullable<QuickFilterControlProps['render']>,
    (...args: never[]) => unknown
  >
>[1];

export type QuickFilterSearchFieldProps = GridSlotProps['baseTextField'] &
  Readonly<{
    state: QuickFilterState;
  }>;

export const QuickFilterSearchField = forwardRef<
  HTMLInputElement,
  Readonly<QuickFilterSearchFieldProps>
>(function QuickFilterSearchField({ state, ...controlProps }, ref) {
  return (
    <TextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...controlProps}
      autoFocus
      inputRef={ref}
      placeholder="Rechercher ..."
      size="small"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <GridSearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: state.value ? (
            <InputAdornment position="end">
              <QuickFilterClear render={<IconButton size="small" />}>
                <GridClearIcon fontSize="small" />
              </QuickFilterClear>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
});
